import { sortBy } from "lodash";
import { Variables } from ".";
import { KioskEvent } from "./types";

type QueueItem = {
  event: KioskEvent;
  variables: Variables;
  context: FeatureContext;
};

let QUEUE: Array<QueueItem> = [];

export function clearQueue(): void {
  QUEUE = [];
}

function drainQueue<T extends (...args: unknown[]) => unknown>(cb: T) {
  if (QUEUE.length === 0) {
    return;
  }

  const queuedEvents = [...QUEUE];
  clearQueue();
  const sortedEvents = sortBy(
    queuedEvents,
    (ev) => ev.event.eventData.occurredAt
  );

  for (const ev of sortedEvents) {
    cb(ev.event, ev.variables, ev.context);
  }
}

export function pushQueue(
  inputEvent: KioskEvent,
  variables: Variables,
  context: FeatureContext,
  cb: (event: KioskEvent, variables: Variables, context: FeatureContext) => void
): void {
  // Timestamp the event to ensure ordering
  const eventData = {
    ...inputEvent.eventData,
    occurredAt: inputEvent.eventData.occurredAt || new Date().toISOString(),
  };
  const event = { ...inputEvent, eventData: eventData };

  QUEUE.push({ event, variables, context });

  setTimeout(() => drainQueue(cb), process.env.NODE_ENV === "test" ? 1 : 100);
}
